import React from "react";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Grid,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { getLocalizedString } from "@icarius-localization/strings";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const gridStyle = { height: 75, padding: "0px 10px" };

const ViewDialog = (props) => {

  const { open, data, handleClose } = props;

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"md"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {getLocalizedString("transactionLog")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <Grid container item xs={12}>
            <Grid container item alignItems="center" xs={12} md={6} style={gridStyle}>
              <TextField
                fullWidth
                margin={"none"}
                value={data['Código de usuario']}
                label={getLocalizedString("userCode")}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} md={6} style={gridStyle}>
              <TextField
                fullWidth
                margin={"none"}
                value={data['Nombre del usuario']}
                label={getLocalizedString("userName")}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} md={6} style={gridStyle}>
              <TextField
                fullWidth
                margin={"none"}
                value={data['Fecha de ejecución']}
                label={getLocalizedString("executionDate")}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} md={6} style={gridStyle}>
              <TextField
                fullWidth
                margin={"none"}
                value={data['Hora de ejecución']}
                label={getLocalizedString("executionTime")}
              />
            </Grid>
            <Grid container item alignItems="center" xs={12} style={{ padding: "20px 10px" }}> {/* sql */}
              <TextFieldMultiline
                fullWidth
                label={getLocalizedString("sqlStatements")}
                rows={15}
                margin={"none"}
                value={data['Sentencias de SQL']}
                inputProps={{ spellCheck: 'false' }}
              />
            </Grid>
          </Grid>
        </DialogContent>
      </div>
    </Dialog>
  );
}

export default ViewDialog;
